import { render } from "./PayrollWorkspace.vue?vue&type=template&id=31895d34&scoped=true&ts=true"
import script from "./PayrollWorkspace.vue?vue&type=script&lang=ts"
export * from "./PayrollWorkspace.vue?vue&type=script&lang=ts"

import "./PayrollWorkspace.vue?vue&type=style&index=0&id=31895d34&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31895d34"]])

export default __exports__